var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFirefly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 28,
    viewBox: "0 0 170 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "firefly_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 170,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .993h170v26.014H0V.993z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#firefly_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.989 27.007H0V.993h22.626v6.764H7.989v4.817h12.227v6.763H7.989v7.67zM26.07.993h7.99v26.014h-7.99V.993zm30.175 26.014l-5.51-6.764H46.19v6.764h-7.989V.993H53.25c8.057 0 12.017 3.429 12.017 9.259 0 4.123-1.96 7.39-5.989 8.98l6.584 7.765h-9.606l-.01.01zM46.19 13.48h7.06c2.93 0 4.412-.828 4.412-2.812 0-1.985-1.484-2.91-4.412-2.91h-7.059l-.001 5.722zM68.607.993h23.316v6.764H76.594v2.563h12.916v6.764H76.595v3.16h15.328v6.763H68.605L68.607.993zM103.7 27.007h-7.99V.993h22.627v6.764H103.7v4.817h12.226v6.763H103.7v7.67zM121.781.993h7.99v19.25h13.948v6.764h-21.938V.993zm28.587 17.17L138.39.993h9.71l6.478 9.847 6.543-9.847h8.889l-11.643 17.17v8.844h-7.989v-8.846h-.01v.002z",
    fill: "#000"
  }))));
}

export default SvgFirefly;